import axios from "axios";

const axiosInstance = axios.create({
	baseURL: "https://lws-server-1494.herokuapp.com/",
});

export default axiosInstance;
